import { render, staticRenderFns } from "./TablePeriodSwitcher.vue?vue&type=template&id=66d9e827&scoped=true"
import script from "./TablePeriodSwitcher.vue?vue&type=script&lang=js"
export * from "./TablePeriodSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TablePeriodSwitcher.vue?vue&type=style&index=0&id=66d9e827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9e827",
  null
  
)

export default component.exports